import { render } from "./PlanningPatientDatatableActions.vue?vue&type=template&id=012b1222"
import script from "./PlanningPatientDatatableActions.vue?vue&type=script&lang=js"
export * from "./PlanningPatientDatatableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__